import Chip from "@mui/material/Chip";
import React from "react";

const stateColors = {
    DRAFT: "#f0f0f0", // Light gray
    READY_TO_REVIEW: "#ffeb3b", // Yellow  
    REVIEWED: "#4caf50", // Green
    PUBLISHED: "#2196f3", // Blue

};

const CustomStateChip = ({ label, ...props }) => {
    const backgroundColor = stateColors[label] || "#e0e0e0"; // Default to a neutral color if the label doesn't match
    
    // Determine text color based on background for better contrast
    const getTextColor = (bgColor) => {
        // Light backgrounds need dark text, dark backgrounds need light text
        const lightBackgrounds = ["#f0f0f0", "#ffeb3b", "#e0e0e0"];
        return lightBackgrounds.includes(bgColor) ? "#333" : "#fff";
    };
    
    const textColor = getTextColor(backgroundColor);

    return (
        <Chip
            label={label} // Set the label from the parameter
            style={{ backgroundColor, color: textColor, textTransform: "none" }} // Apply the background color and appropriate text color
            {...props} // Pass down other props to the Chip component
        />
    );
};

export default CustomStateChip;
